var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header-user"}},[_c('i',{staticClass:"el-icon-user"}),_vm._v("\n  "+_vm._s(_vm.userName)),_c('span',{staticClass:"divider"},[_vm._v("|")]),_c('span',{staticClass:"logout",on:{"click":_vm.logout}},[_vm._v("退出登录")])])}
var staticRenderFns = []

export { render, staticRenderFns }